module.exports = __webpack_public_path__ + "media/top.0aeeb39b.wav";